// extracted by mini-css-extract-plugin
module.exports = {"secondary-page-title":"secondary-page-title_secondary-page-title__li8hx","secondary-page-title__counter":"secondary-page-title_secondary-page-title__counter__MHr5D"};